import axios from 'axios'
import config from '../config'
import { getPatientToken } from '../utils'

const bookAppointmentApi = async(params) => {
    const response = await axios({
        url: `${config.api.base_url}book-appointment?type=${params.type}`,
        method: "post",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getPatientToken()}`
        }
    })
    return response
}

export default bookAppointmentApi